const awsUser = {
    "aws_cognito_identity_pool_id": "us-east-1:d3708511-4409-4327-be18-47452870133d",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_kc0P4U7YH",
    "aws_user_pools_web_client_id": "2r1j7mbji23eo4qoujo8ncm1dd",
    "oauth": {
        "domain": "ganimarketevent.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile", 
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:4200",
        "redirectSignOut": "http://localhost:4200",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS"
}

export default awsUser; 